import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

const CoffeeMug = () => (
  <svg
    className="w-5 h-5 flex-no-shrink fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-2 -2 600 600"
  >
    <path d="M422 211v-30H30v75c0 69.501 36.669 131.461 91.558 166h207.884c13.48-8.483 26.829-18.594 37.837-30H407c57.891 0 105-47.109 105-105v-76h-90zm60 76c0 41.353-33.647 75-75 75h-16.326C410.287 331.652 422 294.763 422 256v-15h60v46zM0 452c0 33.137 26.863 60 60 60h332c33.137 0 60-26.863 60-60H0z" />
    <g id="steam">
      <path d="M160.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L160.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48zM235.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L235.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48zM310.068 0l-16.641 24.961c5.962 3.97 9.375 10.356 9.375 17.52s-3.413 13.55-9.375 17.52c-14.238 9.492-22.734 25.371-22.734 42.48 0 17.109 8.496 32.988 22.734 42.48L310.067 120c-5.962-3.97-9.375-10.356-9.375-17.52s3.413-13.55 9.375-17.52c14.239-9.491 22.735-25.37 22.735-42.48 0-17.109-8.496-32.988-22.734-42.48z" />
    </g>
  </svg>
)

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const FeaturedPosts = ({ content, cta = true }) => {
  return (
    <section
    id="featuredPosts"
    className="w-10/12 lg:w-1/2 xl:w-7/12 mx-auto snap-center scroll-mt-44 lg:scroll-mt-60"
    >
      <p className="font-body2 text-3xl md:text-4xl lg:text-5xl font-bold mb-12 uppercase text-center tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white">
        Recent Articles
      </p>
      <ul className="w-full snap-y mt-24">
        {content.map((featured, key) => {
          const { excerpt, id, body, frontmatter, timeToRead, fields } =
            featured.node
          const idx = key
          return (
            <FadeInWhenVisible>
                <li
                  className="flex items-center justify-between mb-8"
                  key={idx}
                >
                  <Link to={fields.slug} itemProp="url">
                      <article
                        className="post-list-item"
                        itemScope
                        itemType="http://schema.org/Article"
                      >
                        <div className="flex flex-col overflow-hidden w-full hover:bg-blue-100 dark:hover:bg-secondary rounded-md p-2">
                          <p className="flex text-xs sm:text-sm md:text-md font-bold text-gray-500">
                            {frontmatter.date}
                            <span className="">
                              &nbsp;&bull;&nbsp;{timeToRead} min read &bull;&nbsp;
                            </span>
                            <div className="inline-block">
                              <CoffeeMug />
                            </div>
                          </p>

                          <h1 className="font-body2 text-xl md:text-2xl lg:text-3xl font-bold mb-2 text-quarternary leading-tight"  itemProp="headline">
                            {frontmatter.title}
                          </h1>
                          <small className="font-body2 text-sm sm:text-lg md:text-xl font-light">
                            {frontmatter.description}
                          </small>
                        </div>
                      </article>
                  </Link>
                </li>
            </FadeInWhenVisible>
          )
        })}
      </ul>
      {!cta ? null : (
          <Link to="/blog" className="flex justify-center" aria-label="See more blogs">
            <button className="mt-10 inline-block w-auto font-bold text-sm sm:text-md md:text-lg lg:text-2xl cursor-pointer transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100 border-2 border-blue-200 dark:border-gray-600  hover:border-blue-500 dark:hover:border-white rounded-full">
            <div class="flex flex-cols-1">
                <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-secondary-text hover:text-quarternary px-6 py-4 space-x-3 md:px-11 md:py-6 md:space-x-5">See more</span>
            </div> 
          </button>
          </Link>
      )}
    </section>
  )
}

export default FeaturedPosts
